import { Typography } from '@mui/material';
import { useCreateMessage } from '_api';
import { MessagePayload } from '_api/types';
import { SEVERITY } from '_constants/derived';
import { DefaultNewMessage } from '_constants/object-templates';
import { StyledFormLabel } from 'components/atoms';
import { AlertMessage, BaseModal } from 'components/molecules';
import { NewMessageForm } from 'components/organisms/forms';
import React, { useState } from 'react';

import { MessageModalProps } from './types';

export const NewMessageModal = ({
  defaultReceiverId = 0,
  defaultReceiverText,
  open,
  onClose,
}: MessageModalProps) => {
  const { mutateAsync: createMessage } = useCreateMessage();
  const [errorMessage, setErrorMessage] = useState('');
  const [showSuccess, setShowSuccess] = useState(false);
  const [disabledSubmit, setDisabledSubmit] = useState(false);

  const onSubmit = (newMessage: MessagePayload) => {
    const { filename } = newMessage;
    const payload = {
      ...newMessage,
      filename: filename === '' ? undefined : filename,
      type: filename && filename.length > 0 ? 'FILE' : 'TEXT',
    } as MessagePayload;
    setDisabledSubmit(true);

    createMessage(payload)
      .then((data) => {
        if (data && data.id) {
          setShowSuccess(true);
          setTimeout(() => {
            setDisabledSubmit(false);
            setShowSuccess(false);
            onClose();
          }, 2000);
        }
      })
      .catch((err) => {
        setDisabledSubmit(false);
        setErrorMessage(err.message);
        setTimeout(() => {
          setErrorMessage('');
        }, 3500);
      });
  };

  return (
    <BaseModal open={open} onClose={onClose} title={'New Message'}>
      <>
        {defaultReceiverId && defaultReceiverText ? (
          <>
            <StyledFormLabel>TO</StyledFormLabel>
            <Typography sx={{ padding: '5px' }}>{defaultReceiverText}</Typography>
          </>
        ) : null}
        <NewMessageForm
          initValue={{
            ...DefaultNewMessage,
            receiverId: defaultReceiverId,
          }}
          disableSelect={defaultReceiverId === 0}
          onBack={onClose}
          onSubmit={onSubmit}
          disableAll={disabledSubmit}
        />
      </>
      <AlertMessage
        open={showSuccess}
        onClose={() => setShowSuccess(false)}
        message={'MESSAGE SENT!'}
      />
      <AlertMessage
        open={!!errorMessage}
        onClose={() => setErrorMessage('')}
        severity={SEVERITY.error}
        message={
          <>
            Failed to send message
            <br />
            {errorMessage}
            <br />
            Resolve issues and try again.
          </>
        }
      />
    </BaseModal>
  );
};
